<template>
  <v-card>
    <v-data-table :headers="headers"
                  :items="reviews"
                  :options.sync="options"
                  :footer-props="dataTableFooterProps"
                  :server-items-length="totalReviews"
                  :loading="reviewsLoading"
                  disable-sort
                  loading-text="Loading... Please wait">

      <template v-slot:top>
        <v-card-title class="grey--text text--darken-2">
          <v-icon class="mx-3">
            mdi-play-box-multiple-outline
          </v-icon>
          Reviews
        </v-card-title>

        <v-card-title>
          <v-btn class="mr-5 ml-2"
                 rounded
                 color="primary"
                 dark
                 x-large
                 @click="addItem()"
          >
            <v-icon
            >
              mdi-plus
            </v-icon>
            Add a Review
          </v-btn>

          <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search Reviews"
              single-line
              hide-details
              filled
              rounded
              placeholder="Search reviews"
              class="mr-5"
              clearable
              @click="clear"
              color="primary"
          ></v-text-field>

          <RefreshTableHeader :action="refresh" />

        </v-card-title>
      </template>

      <template v-slot:item.actions="{ item }">

        <v-btn x-small
               depressed
               class="pa-3 ma-1"
               @click="editItem(item)">
          <v-icon small>
            mdi-pencil
          </v-icon>
        </v-btn>

        <v-btn
            x-small
            depressed
            @click="deleteItem(item)"
            class="pa-3 ma-1">
          <v-icon small color="primary">
            mdi-close
          </v-icon>
        </v-btn>
      </template>

      <template v-slot:[`footer.page-text`]="items">
        <RefreshTableFooter :item="items" :action="refresh"/>
      </template>

      <template v-slot:item.tags="{ item }">
        <TagsDisplay :items="item.tags"/>
      </template>

    </v-data-table>

    <ReviewAdd/>
    <ReviewEdit/>
    <ReviewDelete/>

  </v-card>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import ReviewAdd from "@/components/Reviews/ReviewAdd";
import ReviewDelete from "@/components/Reviews/ReviewDelete";
import ReviewEdit from "@/components/Reviews/ReviewEdit";
import RefreshTableHeader from "@/components/common/RefreshTableHeader";
import RefreshTableFooter from "@/components/common/RefreshTableFooter";
import {debounce} from "@/utility";
import TagsDisplay from "@/components/common/TagsDisplay";

export default {
  name: "Reviews",
  components: {RefreshTableFooter, RefreshTableHeader, ReviewAdd, ReviewEdit, ReviewDelete, TagsDisplay},
  computed: {
    ...mapState([
      'reviewsLoading', 'totalReviews',
    ]),
    ...mapGetters(['reviews', 'reviewsLoading', 'totalReviews', 'currentReviewItem', 'dataTableFooterProps']),
  },
  methods: {
    ...mapActions([
      'getReviews',
      'getReview',
      'clearReviewApiError',
      'setOpenDialog',
      'setReviewPaginationOptions',
      'setReviewsSearch',
    ]),
    addItem() {
      this.clearReviewApiError();
      this.setOpenDialog('reviewAdd');
    },
    async editItem(item) {
      this.clearReviewApiError();
      this.setOpenDialog('reviewEdit');
      await this.getReview(item);
      if (!this.currentReviewItem) {
        this.getReviews();
      }
    },
    async deleteItem(item) {
      this.clearReviewApiError();
      this.setOpenDialog('reviewDelete');
      await this.getReview(item);
      if (!this.currentReviewItem) {
        this.getReviews();
      }
    },
    refresh() {
      this.getReviews();
    },
    clear() {
      this.setReviewsSearch('');
    },
  },
  mounted () {
    this.setReviewsSearch('');
    this.getReviews();
  },
  data() {
    return {
      search: '',
      debouncedSearch: '',
      options: {
        itemsPerPage: 10,
      },
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: '_id',
        },
        {
          text: 'Title',
          align: 'start',
          value: 'title',
        },
        {
          text: 'Review',
          align: 'start',
          value: 'review',
        },
        {
          text: 'Author',
          align: 'start',
          value: 'author',
        },
        {
          text: 'Tags',
          align: 'start',
          value: 'tags',
        },
        {
          text: 'Actions',
          value: 'actions',
          sortable: false,
        },
      ],
    };
  },
  watch: {
    options: {
      handler() {
        this.setReviewPaginationOptions(this.options);
        this.getReviews();
      },
      deep: true,
    },
    search: debounce(function(newVal) {
      this.debouncedSearch = newVal;
    }, 500),
    debouncedSearch: {
      handler() {
        this.setReviewsSearch(this.search ?? '');
        this.getReviews();
      },
    },
  },
};
</script>